import axios from '../axios';
import { endPoints } from '../endpoints';
import {
  UmbrellaRateCalculatorParams,
  UmbrellaRateCalculatorResponse,
  RateConfigsResponse,
} from '@nxsys/types/models/kid/umbrella-rate-calculator';

export const calculateUmbrellaRateApi = async (
  params: UmbrellaRateCalculatorParams,
): Promise<UmbrellaRateCalculatorResponse> => {
  const response = await axios.post(
    endPoints.umbrellaRateCalculator.calculate,
    params,
  );
  return response.data;
};

export const getRateConfigsApi = async (
  taxYear: number,
): Promise<RateConfigsResponse> => {
  const response = await axios.get(
    endPoints.umbrellaRateCalculator.rateConfigs,
    { params: { taxYear } },
  );
  return response.data;
};
